<template>
  <header class="dashboard-page-header">
    <div class="dashboard-page-header-text">
      <h1 class="dashboard-page-header-title">{{ title }}</h1>
      <p v-if="subtitle" class="dashboard-page-header-subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.actions" class="dashboard-page-header-actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
// Promoted from the M4 insights page header so every dashboard page
// (Insights / Branding / Web page / Employees / Account) renders with
// identical typography: 24px/800/-0.3px title + 14px/muted subtitle on
// the shared `--lulu-text-strong` + `--lulu-text-muted` tokens.
export default {
  name: "DashboardPageHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
  },
};
</script>

<style scoped>
.dashboard-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.dashboard-page-header-text {
  min-width: 0;
}

.dashboard-page-header-title {
  font-size: 24px;
  font-weight: 800;
  color: var(--lulu-text-strong);
  margin: 0;
  letter-spacing: -0.3px;
}

.dashboard-page-header-subtitle {
  font-size: 14px;
  color: var(--lulu-text-muted);
  margin: 4px 0 0;
  line-height: 1.5;
}

.dashboard-page-header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
</style>
